import { WeekdayType } from "@/gql/generated/graphql";

export const gradeText: Record<string, string> = {
  '0': 'A1',
  '1': 'A2',
  '2': 'A3',
  '3': 'B1',
  '4': 'B2',
  '5': 'B3',
  '6': 'C1',
  '7': 'C2',
  '8': 'C3',
}

export const skillStepImagePath: string =
  'https://asset.logic.sonyged.com/images/skill-steps'

export const primarySkillsColor: Record<
  string,
  { name: string; bgColor: string; textColor: string }
> = {
  calculation: {
    name: '計算力',
    bgColor: 'bg-[#3B97DA]',
    textColor: 'text-[#3B97DA]',
  },
  information_reading: {
    name: '情報読解力',
    bgColor: 'bg-[#36A27C]',
    textColor: 'text-[#36A27C]',
  },
  searching: {
    name: '探索力',
    bgColor: 'bg-[#8A9C00]',
    textColor: 'text-[#8A9C00]',
  },
  spatial_perception: {
    name: '空間認識力',
    bgColor: 'bg-[#A99223]',
    textColor: 'text-[#A99223]',
  },
}

export const primarySkillNameMap: Record<string, string> = {
  '算数思考力': '論理的思考力',
  '算数活用力': '学習の基礎力',
}

export const curriculumPrimarySkillsColor: Record<
  string,
  { name: string; bgColor: string; textColor: string }
> = {
  basic_spatial_perception: {
    name: '空間認識力',
    bgColor: 'bg-[#A99223]',
    textColor: 'text-[#A99223]',
  },
  basic_logical_calculation: {
    name: '論理的思考力',
    bgColor: 'bg-[#36A27C]',
    textColor: 'text-[#36A27C]',
  },
  basic_practical_calculation: {
    name: '学習の基礎力',
    bgColor: 'bg-[#3B97DA]',
    textColor: 'text-[#3B97DA]',
  },
}

export const MINUTE_TO_MILLISECOND = 60000

export const LICENSE_CODE_LENGTH = 12
export const LICENSE_BOX = 3

export const SCHOOL_CODE_LENGTH = 12
export const SCHOOL_CODE_BOX = 3

export const primarySkillColors = {
  calculation: '#3B97DA',
  information_reading: '#36A27C',
  searching: '#8A9C00',
  spatial_perception: '#A99223',
  basic_spatial_perception: '#3B97DA',
  basic_logical_calculation: '#36A27C',
  basic_practical_calculation: '#8A9C00',
  curriculum_calculation: '#3B97DA',
  curriculum_information_reading: '#36A27C',
  curriculum_searching: '#8A9C00',
  curriculum_spatial_perception: '#A99223'
} as const

export const programmerLevelColors: Record<string, Record<string, string>> = {
  secondary: {
    baseColor: 'bg-secondary-70',
    yourLevelText: 'text-secondary-50',
    title: 'text-secondary-40',
    starColor: 'text-secondary-70',
  },
  mint: {
    baseColor: 'bg-mint-70',
    yourLevelText: 'text-mint-60',
    title: 'text-mint-50',
    starColor: 'text-mint-70',
  },
  water: {
    baseColor: 'bg-water-70',
    yourLevelText: 'text-water-60',
    title: 'text-water-50',
    starColor: 'text-water-70',
  },
  grape: {
    baseColor: 'bg-grape-70',
    yourLevelText: 'text-grape-60',
    title: 'text-grape-50',
    starColor: 'text-grape-70',
  },
  orange: {
    baseColor: 'bg-orange-70',
    yourLevelText: 'text-orange-60',
    title: 'text-orange-50',
    starColor: 'text-orange-70',
  },
  apple: {
    baseColor: 'bg-apple-70',
    yourLevelText: 'text-apple-60',
    title: 'text-apple-50',
    starColor: 'text-apple-70',
  },
}

export const WEEKDAY_OPTIONS: { name: WeekdayType; label: string }[] = [
  { name: WeekdayType.Monday, label: '月' },
  { name: WeekdayType.Tuesday, label: '火' },
  { name: WeekdayType.Wednesday, label: '水' },
  { name: WeekdayType.Thursday, label: '木' },
  { name: WeekdayType.Friday, label: '金' },
  { name: WeekdayType.Saturday, label: '土' },
  { name: WeekdayType.Sunday, label: '日' },
]
